/* eslint-disable prettier/prettier */
import ChatServices from 'src/services/ChatServices'
import { chatConstant } from '../constants/chatConstant'

export const setSelectedChat = (selectedChat) => {
  return {
    type: 'SET_SELECTED_CHATS',
    payload: selectedChat,
  }
}

export const setChats = (chats) => {
  return {
    type: 'SET_CHATS',
    payload: chats,
  }
}

export const chatActions = (payload) => (dispatch) => {
  ChatServices.accessChat(payload)
    .then((data) => {
      console.log("Front Chat Actions", data)
      dispatch({
        type: chatConstant.CHAT_ACCESS_SUCCESS,
        payload: data.data,
      })
    })
    .catch((err) => {
      dispatch({
        type: chatConstant.CHAT_ACCESS_FAILED,
        payload: err,
      })
    })
}
